
import { LoginErrorEnum } from '../_enums/login-error.enum';


export class AuthenticateResponse {
    userID: number;
    hasError: boolean;
    errorID: LoginErrorEnum;
}


// WEBPACK FOOTER //
// ./src/app/_models/authenticate-response.model.ts